import { Form, Row, Col, DatePicker, InputNumber, Flex, Tooltip } from "antd";
import MultiSelectTag from "../../../components/multi-select-tag";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../constants/common";
import { ISuppliersByNameResult } from "../../../interfaces/supplier";
import { IMasterDataType } from "../../../interfaces/master-data";
import { listStatusInvoice } from "../../../utils/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

interface FilterInvoiceProps {
  dropdownsData: any;
}

const FilterInvoice: React.FC<FilterInvoiceProps> = ({ dropdownsData }) => {
  const {
    currencies = [],
    suppliers = [],
  } = dropdownsData || {};

  const renderLabelInfo = (label: string) => {
    return (
      <Flex align="center" gap={5}>
        <span>{label}</span>
        <Tooltip title="Type keywords, separate with commas. Use space (‘ ’) for blank results.">
          <FontAwesomeIcon icon={faInfoCircle} />
        </Tooltip>
      </Flex>
    );
  };

  return (
    <>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item label="Supplier Code" name="supplierCodes">
            <MultiSelectTag
              allowClear
              showSearch
              placeholder="All"
              options={suppliers.map((item: ISuppliersByNameResult) => ({
                value: item.code,
                label: `${item.code} - ${item.label}`,
              }))}
              tagDisplay="value"
            />
          </Form.Item>
        </Col>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <>
              <Col span={12}>
                <Form.Item label="Received Date From" name="receivedDateFrom">
                  <DatePicker
                    format={DATE_FORMAT}
                    maxDate={dayjs(getFieldValue("receivedDateTo"), DATE_FORMAT)}
                    style={{ width: "100%" }}
                    placeholder="From"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Received Date To" name="receivedDateTo">
                  <DatePicker
                    format={DATE_FORMAT}
                    minDate={dayjs(getFieldValue("receivedDateFrom"), DATE_FORMAT)}
                    style={{ width: "100%" }}
                    placeholder="To"
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Form.Item>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <>
              <Col span={12}>
                <Form.Item label="Invoice Date From" name="invoiceDateFrom">
                  <DatePicker
                    format={DATE_FORMAT}
                    maxDate={dayjs(getFieldValue("invoiceDateTo"), DATE_FORMAT)}
                    style={{ width: "100%" }}
                    placeholder="From"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Invoice Date To" name="invoiceDateTo">
                  <DatePicker
                    format={DATE_FORMAT}
                    minDate={dayjs(getFieldValue("invoiceDateFrom"), DATE_FORMAT)}
                    style={{ width: "100%" }}
                    placeholder="To"
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Form.Item>
        <Col span={24}>
          <Form.Item label="Status" name="statuses">
            <MultiSelectTag
              allowClear
              showSearch
              placeholder="All"
              options={listStatusInvoice.map((item: string) => ({
                value: item.toString(),
                label: item,
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Currency" name="currencies">
            <MultiSelectTag
              allowClear
              showSearch
              placeholder="All"
              options={currencies.map((item: IMasterDataType) => ({
                value: item.code,
                label: `${item.code} - ${item.label}`,
              }))}
              tagDisplay="value"
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label={renderLabelInfo("Booking Reference")} name="bookingRefs">
            <MultiSelectTag
              allowClear
              showSearch
              placeholder="All"
              options={[]}
              mode="tags"
            />
          </Form.Item>
        </Col>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <>
              <Col span={12}>
                <Form.Item label="From Total Cost" name="totalCostFrom">
                  <InputNumber
                    max={getFieldValue("totalCostTo")}
                    style={{ width: "100%" }}
                    placeholder="From"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="To Total Cost" name="totalCostTo">
                  <InputNumber
                    min={getFieldValue("totalCostFrom") || 1}
                    style={{ width: "100%" }}
                    placeholder="To"
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Form.Item>
        
      </Row>
    </>
  );
};

export default FilterInvoice;
